// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import * as React from "react";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import Tooltip, { TooltipPresentationProps } from "@store/MobiusOverrides/Tooltip/Tooltip";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { extractStylesToArray, isSafe } from "@insite/client-framework/Common/Utilities/isSafeStyles";
import { css } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";
import InfoLine from "@store/Library/Components/Toolkit/Icons/Info/InfoLine";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";

const enum fields {
    content = "content",
}

interface Props extends WidgetProps {
    fields: {
        [fields.content]: string;
    };
}

export interface ProductDetailsQuoteProcessStyles {
    wrapper?: InjectableCss;
    text?: TypographyPresentationProps;
    tooltip?: TooltipPresentationProps;
}

export const productDetailsQuoteProcessStyles: ProductDetailsQuoteProcessStyles = {
    wrapper: {
        css: css`
            padding: ${pxToRem(10, 0)};
        `,
    },
    text: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
            color: ${getColor("tag.color")};
        `,
    },
    tooltip: {
        iconProps: {
            src: InfoLine,
            color: "swatch.black",
        },
        cssOverrides: {
            tooltipContainer: css`
                width: 350px;

                ${breakpoint("sm", "down")} {
                    width: 250px;
                    transform: translateX(-25%);
                }
            `,
            tooltipBody: css`
                text-align: left;
                background-color: ${getColor("common.accent")};
                font-size: ${x => x.theme.design.typography.size.smallest};
            `,
            tooltipArrow: css`
                border-color: ${getColor("common.accent")} transparent transparent transparent;

                ${breakpoint("sm", "down")} {
                    left: 25%;
                }
            `,
        },
        mergeCss: true,
    },
};

const styles = productDetailsQuoteProcessStyles;

const ProductDetailsQuoteProcess = ({ fields: { content } }: Props) => {
    if (!content) {
        return null;
    }

    const parsedContent = parse(content, parserOptions);

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.text}>{translate("Quote process")}</Typography>
            <Tooltip {...styles.tooltip} text={parsedContent} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsQuoteProcess,
    definition: {
        displayName: "Quote Process",
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.content,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                isRequired: true,
                validate: (html: string) => {
                    const arrayOfStyles = extractStylesToArray(html);
                    return arrayOfStyles?.every(style => isSafe(style))
                        ? null
                        : "The HTML contains invalid styles that prevent it from being saved";
                },
            },
        ],
    },
};

export default widgetModule;
